import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import $ from "jquery";

class ModalAlert extends Component {

    constructor(props) {
        // console.log(props);
        super(props);
        this.state = {
            redirectURL: ""
        }
    }

    componentWillMount() {
        let mount = $("div").hasClass("modal-backdrop");
        if (mount == true) {
            $('body').removeClass('modal-open');
            $(".modal-backdrop").remove();
        }
    }

    redirectSomePage = (redirect_url) => {
        if(redirect_url != '')
        {
            this.setState({
                redirectURL:redirect_url
            })
        }
    }

    render() {

        if(this.state.redirectURL!=='') {
            return(<Redirect to={this.state.redirectURL} />);
        }

        if(this.props.modalType=='CONFIRM')
        {
            return(
                <div className="modal fade dialogbox" id="ModalAlert" data-backdrop="static" tabIndex="-1" role="dialog">
                  <div className="modal-dialog" role="document">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">{this.props.modalTitle}</h5>
                      </div>
                      <div className="modal-body">{this.props.Notifications}</div>
                      <div className="modal-footer">
                        <div className="btn-inline"> 
                            <button type="button" className="btn btn-text-secondary" data-dismiss="modal">CANCEL</button> 
                            <button type="button" onClick={this._clickConfrim} className="btn btn-text-primary" data-dismiss="modal">CONFIRM</button> 
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            );
        }
        else 
        {
            return(
                <div className="modal fade dialogbox overlay-back" id="ModalAlert" data-backdrop="static" tabIndex="-1" role="dialog">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            {this.props.type=='error' &&
                                <div className="modal-icon text-danger mb-2">
                                    <ion-icon name="close-circle"></ion-icon>
                                </div>
                            }

                            {this.props.type=='success' &&
                                <div className="modal-icon text-success mb-2">
                                    <ion-icon name="checkmark-circle"></ion-icon>
                                </div>   
                            }

                            <div className="modal-body"> 
                                <p className="pb-0 mb-0" dangerouslySetInnerHTML={{ __html: this.props.Notifications}} />
                            </div>
                            <div className="modal-footer">
                                <div className="btn-inline"> 
                                    <button type="button" className="btn" onClick={(this.props.goto_url && this.props.goto_url!="")?(e)=>this.redirectSomePage(this.props.goto_url):undefined} data-dismiss="modal">OK</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

export default ModalAlert;